import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import MenuPage from './index';
import MenuCategoryPage from './[category]';
import MenuItemPage from './[category]/[item]';
import { useMenuDrawer } from '../../components/shared/MenuDrawerProvider';

export default function MenuItemWrapper() {
  const location = useLocation();
  
  // Use memoization to prevent unnecessary re-renders
  return useMemo(() => {
    const pathParts = location.pathname.split('/');
    
    // Check if we're coming from the main menu or a category page
    // If the URL has exactly 4 parts (e.g., /menu/category/item), we need to determine the source
    if (pathParts.length === 4) {
      // If there's NO navigation state, this is a direct access (e.g., from search engines, sitemap, external link)
      // Show the full standalone page for SEO
      if (!location.state || (!location.state.fromMainMenu && !location.state.fromCategory)) {
        return <MenuItemPage />;
      }
      
      // Check if we have a state indicating we came from the main menu
      if (location.state && location.state.fromMainMenu) {
        return <MenuPage />;
      }
      // Otherwise, assume we're coming from a category page
      return <MenuCategoryPage />;
    }
    
    // Fallback to category page (this shouldn't happen with our routing)
    return <MenuCategoryPage />;
  }, [location.pathname, location.state]); // Only re-render when these change
}
